import { useLocation } from 'react-router-dom';

import { useIsSecurityDemoMode } from '@cast/infrastructure-demo';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

export const useSecurityDataOrFixture = <T>(
  data: T | undefined,
  fixture: () => Promise<T>
) => {
  const { pathname } = useLocation();
  const match = pathname.startsWith('/organization/security');

  const isSecurityDemoMode = useIsSecurityDemoMode();
  const showDemoData = match && isSecurityDemoMode;

  return useDataOrFixture(data, fixture, showDemoData);
};
